export const categoryOptionMixin = {
  data() {
    return {
      categoryForm: {
        category_id: ""
      },
      categoryOptions: [],

      categoryFormLoading: false
    };
  },
  methods: {
    fetchCategories(type){
      this.$http.get(`/categories/all?type=${type}`)
      .then(response => {
        if(response.data.success){
          this.categoryOptions = response.data.data
        }
      })
    },
    clearCategoryForm(){
        Object.keys(this.categoryForm).forEach(key => {
            this.categoryForm[key] = "";
        });
    }
  },
};